import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { COLORS3 as COLORS, FONT } from '@zola/zola-ui/src/styles/emotion';

export const ProductPriceWrapper = styled.div<{ isPDPRedesignExperiment?: boolean }>`
  overflow: hidden;
  white-space: nowrap;

  ${(props) =>
    props.isPDPRedesignExperiment &&
    `
    font-size: ${FONT.FONT_SIZE_SMALL};
  `}
`;

export const OnPromotion = styled.span<{ isPDPRedesignExperiment?: boolean }>`
  color: ${COLORS.ROSE_100};

  ${(props) =>
    props.isPDPRedesignExperiment &&
    `
    font-size: ${FONT.FONT_SIZE_SMALL};
  `}
`;

export const StyledLink = styled(LinkV2)`
  &:hover {
    text-decoration: underline !important;
  }
`;
